import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Menubar from '../Navbar/MenuBar.jsx';

export const DeviceLayout = () => (
  <Container maxWidth="100%">
    <main>
      <Outlet />
    </main>
  </Container>
);

const Layout = () => {
  return (
    <Container maxWidth="100%">
      <Menubar />
      <main>
        <Outlet />
      </main>
    </Container>
  );
};

export default Layout;
